export default __webpack_public_path__ + "static/media/mail.48b4cc1d.svg";